import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Box, Grid, Divider } from "@material-ui/core";
import usePages from "../../../motion/usePages";
import { Page } from "../../../motion/Page";
import { transform, motion } from "framer-motion";
const Product = (props) => {
  return (
    <Box display="flex" p="10px">
      <div style={{ width: "160px", height: "140px", marginRight: "15px" }}>
        <motion.img
          src={props.image}
          style={{
            userSelect: "none",
            userDrag: "none",
            pointerEvents: "none",
            borderRadius: "10px",
            objectFit: "cover",
            maxHeight: "400px",
          }}
          height="100%"
          width="100%"
          alt="shirt"
        />
      </div>
      <Box>
        <Typography style={{ fontWeight: 650, fontSize: 18 }} gutterBottom>
          {props.title}
        </Typography>
        <Typography style={{ fontWeight: 500 }} gutterBottom variant="body1">
          Price: ${props.price}
        </Typography>
        <Typography style={{ fontWeight: 500 }} gutterBottom variant="body1">
          Size: {props.size}
        </Typography>
        <Typography style={{ fontWeight: 500 }} gutterBottom variant="body1">
          Color: {props.color}
        </Typography>
      </Box>
    </Box>
  );
};
const CheckoutSuccess = () => {
  const { cart: data, orderInfo, cartTotal } = useSelector((s) => s.shirt);
  // const { name, city, state, email, zipcode, phone } = orderInfo;
  const pages = usePages({
    data,
    PageContent: Product,
    width: "auto",
    height: "auto",
    color: ["#f0f0f0", "#f7f7f7"],
  });
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        borderRadius: 12,
        height: "100%",
      }}
      py={1.5}
      px={3.5}
    >
      <Typography
        style={{
          fontWeight: 900,
          fontSize: "2.25rem",
        }}
        variant={"h1"}
        gutterBottom
      >
        Order Confirmed.
      </Typography>

      <Box
        bgcolor="white"
        p="30px"
        borderRadius="20px"
        width="100%"
        display="flex"
        height="100%"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        // boxShadow="rgba(0, 0, 0, 0.005) 0px 1px 0px, rgba(0, 0, 0, 0.0) 0px 0px 8px, rgba(0, 0, 0, 0.006) 0px 20px 30px"
      >
        <Box display="flex">
          <Typography
            display="inline"
            style={{
              fontWeight: 900,
              fontSize: "2.25rem",
              marginRight: "10px",
            }}
            variant={"h1"}
            align="center"
          >
            Thank you for choosing
          </Typography>

          <Typography
            display="inline"
            style={{
              fontWeight: 900,
              fontSize: "2.25rem",
              fontFamily: "'Orbitron', sans-serif",
            }}
            variant={"h1"}
            align="center"
          >
            Drip Shop
          </Typography>
        </Box>
        <div style={{ width: "80%", height: "5px" }}>
          <Divider light />
        </div>
        <div style={{ flexGrow: 1 }} />
        <Grid
          container
          justify="space-around"
          alignItems="center"
          spacing={2}
          style={{ maxWidth: "600px", marginTop: "10px", position: "relative" }}
          wrap="nowrap"
        >
          <Grid item>
            <Page
              style={{
                // height: 320,
                width: "600px",
                overflow: "visible",
              }}
              gap={8}
              effect={({ index, normalizedOffset, size }) => {
                return {
                  style: {
                    x:
                      normalizedOffset *
                      -size.width *
                      (0.8 + normalizedOffset * 0.015),
                    y: normalizedOffset * 16,
                    scale: transform(normalizedOffset, [0, 1], [1, 0.85], {
                      clamp: false,
                    }),
                    opacity: normalizedOffset + 1,
                    zIndex: -index,
                  },
                };
              }}
            >
              {pages}
            </Page>
          </Grid>

          <Grid item>
            <Typography
              style={{
                fontWeight: 850,
                fontSize: "2.25rem",
                textDecoration: "underline",
              }}
              variant={"h1"}
              align="center"
              gutterBottom
            >
              Total
            </Typography>
            <Typography
              style={{
                fontWeight: 650,
                fontSize: "2.25rem",
              }}
              variant={"h1"}
              align="center"
              gutterBottom
            >
              ${cartTotal}
            </Typography>
          </Grid>
        </Grid>
        <div style={{ flexGrow: 1 }} />
        <Typography
          style={{
            fontWeight: 650,
            fontSize: "1.25rem",
            color: "rgba(0,0,0,0.2)",
            marginTop: "10px",
          }}
          align="center"
          color="textSecondary"
        >
          You should receive a confirmation email shortly.
        </Typography>
      </Box>
    </Box>
  );
};

export default CheckoutSuccess;
